export const vitrin = {
  title: 'Vitrin',
  titleEN: 'Vitrin',
  description: 'Mynet.com\’da yayınlanan liste içeriklerine benzer olarak oluşturulan, temel amacı marka ve kampanya bilinirliği arttırmak olan kullanıcıya ilgi alanındaki ürünlerin satış linklerini sunan etkileşimli kurgulardır.',
  descriptionEN: 'Vitrin is a page that produces content aimed at increasing product sales while introducing users to new products and enhancing brand awareness. By creating various types of content, it connects users directly with products that they need or that will benefit them.',
  tabs: [
    {
      id: 1,
      title: 'Kategori',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Trendyol Vitrin Kategorisi - Pageskin',
          image: 'https://srv-cdn.onedio.com/store/d34f0c44d03b9f5cd554b661a3e3783d3b5bd10e99e2466fbfc4c7e93e66c862.png',
          category: 'Trendyol',
          modalTitle: 'Trendyol Vitrin Kategorisi - Pageskin',
          modal: 'image'
        },
        {
          id: 2,
          name: 'Tchino Vitrin Kategorisi - Pageskin',
          image: 'https://srv-cdn.onedio.com/store/6414bf8d93b5859eedfd0274d3c1ac6a9c5813ed08aa38370c5f59678151deba.png',
          modalTitle: 'Tchino Vitrin Kategorisi - Pageskin',
          category: 'Tchibo',
          modal: 'image'
        },
        {
          id: 3,
          name: 'Philips Vitrin Kategorisi - Pageskin',
          image: 'https://srv-cdn.onedio.com/store/832150958fac5cacd1194625bb3d59e8d885f1e803f95778fb3aefa9573a10ff.png',
          modalTitle: 'Philips Vitrin Kategorisi - Pageskin',
          category: 'Philips',
          modal: 'image'
        },
        {
          id: 4,
          name: 'Gratis Vitrin Kategorisi - Pageskin',
          image: 'https://srv-cdn.onedio.com/store/02ded75f015e2cc7725fabf1fcc46de8b94c4b04a8e6ae6ca2c33cb48247d254.png',
          modalTitle: 'Gratis Vitrin Kategorisi - Pageskin',
          category: 'Gratis',
          modal: 'image'
        },
        {
          id: 5,
          name: 'THY Vitrin Kategorisi - Pageskin',
          image: 'https://srv-cdn.onedio.com/store/50b477617b27b6c6d15682ad8148a8b68ace668529360b556ee3f23fbb7c720f.png',
          modalTitle: 'THY Vitrin Kategorisi - Pageskin',
          category: 'Thy',
          modal: 'image'
        }
      ]
    },
    {
      id: 2,
      title: 'Affilliate',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/4d9085891d649abdb43a8e192818beb0d9673ea9584f9ccec5ab366206cbada4.png',
          url: 'https://onedio.com/haber/bakimina-ozen-gosterenlerin-tercihi-olan-haftanin-en-cok-satilan-kozmetik-urunleri-1083601',
        }
      ]
    },
    {
      id: 3,
      title: 'Madde Entegrasyonu',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          name: 'Philips Vitrin - Madde Entegrasyonu',
          image: 'https://srv-cdn.onedio.com/store/878ee03109ed1cf87102c5f6b3749295b725fb8c5c49a42271068569e2a9391e.png',
          modalTitle: 'Philips Vitrin - Madde Entegrasyonu',
          modal: 'image'
        }
      ]
    },
  ],
  egTabs: [
    {
      id: 1,
      title: 'Category',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Trendyol Showcase Category - Pageskin',
          image: 'https://srv-cdn.onedio.com/store/d34f0c44d03b9f5cd554b661a3e3783d3b5bd10e99e2466fbfc4c7e93e66c862.png',
          category: 'Trendyol',
          modalTitle: 'Trendyol Showcase Category - Pageskin',
          modal: 'image'
        },
        {
          id: 2,
          name: 'Tchino Showcase Category - Pageskin',
          image: 'https://srv-cdn.onedio.com/store/6414bf8d93b5859eedfd0274d3c1ac6a9c5813ed08aa38370c5f59678151deba.png',
          modalTitle: 'Tchino Showcase Category - Pageskin',
          category: 'Tchibo',
          modal: 'image'
        },
        {
          id: 3,
          name: 'Philips Showcase Category - Pageskin',
          image: 'https://srv-cdn.onedio.com/store/832150958fac5cacd1194625bb3d59e8d885f1e803f95778fb3aefa9573a10ff.png',
          modalTitle: 'Philips Showcase Category - Pageskin',
          category: 'Philips',
          modal: 'image'
        },
        {
          id: 4,
          name: 'Gratis Showcase Category - Pageskin',
          image: 'https://srv-cdn.onedio.com/store/02ded75f015e2cc7725fabf1fcc46de8b94c4b04a8e6ae6ca2c33cb48247d254.png',
          modalTitle: 'Gratis Showcase Category - Pageskin',
          category: 'Gratis',
          modal: 'image'
        },
        {
          id: 5,
          name: 'THY Showcase Category - Pageskin',
          image: 'https://srv-cdn.onedio.com/store/50b477617b27b6c6d15682ad8148a8b68ace668529360b556ee3f23fbb7c720f.png',
          modalTitle: 'THY Showcase Category - Pageskin',
          category: 'Thy',
          modal: 'image'
        }
      ]
    },
    {
      id: 2,
      title: 'Affiliate',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/4d9085891d649abdb43a8e192818beb0d9673ea9584f9ccec5ab366206cbada4.png',
          url: 'https://onedio.com/haber/bakimina-ozen-gosterenlerin-tercihi-olan-haftanin-en-cok-satilan-kozmetik-urunleri-1083601',
        }
      ]
    },
    {
      id: 3,
      title: 'Material Integration',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          name: 'Philips Showcase - Material Integration',
          image: 'https://srv-cdn.onedio.com/store/878ee03109ed1cf87102c5f6b3749295b725fb8c5c49a42271068569e2a9391e.png',
          modalTitle: 'Philips Showcase - Material Integration',
          modal: 'image'
        }
      ]
    },
  ]
}
